<template>
  <v-layout column>
    <v-toolbar dense ref="aToolbar" flat>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn text :disabled="!groupItem.own || !dirty" @click="onSave()" color="primary" ><v-icon>mdi-floppy</v-icon>&nbsp;{{ $t('GENERIC_SAVE') }}</v-btn><br /><!-- mdi-content-save-outline -->
        <v-btn text :disabled="!groupItem.item" @click="onSaveAs()"><v-icon>mdi-floppy</v-icon>&nbsp;{{ $t('GENERIC_SAVEAS') }}</v-btn><br /><!-- mdi-content-save-settings-outline -->
        <v-btn text :disabled="!groupItem.own || !groupItem.item" @click="onDelete" color="red darken-1" ><v-icon>mdi-trash-can-outline</v-icon>&nbsp;{{ $t('GENERIC_DELETE') }}</v-btn><br />
        <v-btn text :disabled="!groupItem.own || !dirty" @click="editGroup(groupItem.item || 'new')"><v-icon>mdi-close-box-outline</v-icon>&nbsp;{{ $t('GENERIC_DISCARD') }}</v-btn><br />
<v-btn v-if="isDebug" fab small color="grey lighten-3" class="btn-debug" @click="debug=!debug"><v-icon>mdi-bug-outline</v-icon></v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-card>
      <v-card-text>
        <v-form ref="form">
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm6>
                <v-text-field
                  v-model="groupItem.name"
                  :rules="[rules.required, rules.count]"
                  :label="$t('EXTSEARCH_NAME_GROUP')"
                  @change="dirty=true"
                ></v-text-field>
                <p>{{ $t('EXTSEARCH_USAGE_TOTAL_1') }} <strong>{{ $t('EXTSEARCH_USAGE_TOTAL_2', [groupItem.count]) }}</strong></p>
                <v-chip v-if="debug" label>selectedFolder: {{ selectedFolder }}</v-chip>
              </v-flex>
              <v-flex xs12 sm6 text-xs-right>
                <v-btn
                  color="blue darken-1"
                  dark
                  @click.stop="onRun()"
                >{{ $t('EXTSEARCH_PREVIEW_GROUP') }}&nbsp;<v-icon>mdi-play-circle-outline</v-icon></v-btn>
              </v-flex>
              <v-flex xs12>
                <v-subheader>{{ $t('EXTSEARCH_CONFIG_GROUP') }}</v-subheader>
              </v-flex>
              <v-flex xs12>
                <v-sheet color="grey lighten-3">
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex>
                        <QuickSearch @select="onSelect" :placeholder="$t('HEADER_QUICKSEARCH_LABEL')" />
                      </v-flex>
                    </v-layout>
                    <v-layout wrap>
                      <v-flex>
                        <!-- contacts -->
                        <span v-if="debug">{{ groupItem.contacts }}</span>
                        <v-list>
                          <v-list-item
                            v-for="(contact) in groupItem.contacts"
                            :key="contact.value"
                            dense
                          >
                            <v-list-item-action>
                              <v-btn icon @click="onRemove(contact.value)"><v-icon>mdi-close</v-icon></v-btn>
                            </v-list-item-action>
                            <v-list-item-content>
                              <v-list-item-title v-text="contact.text"></v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-sheet>
              </v-flex>
              <v-flex offset-sm6 text-xs-right>
                <v-btn
                  color="blue darken-1"
                  dark
                  @click.stop="onRun()"
                >{{ $t('EXTSEARCH_PREVIEW_GROUP') }}&nbsp;<v-icon>mdi-play-circle-outline</v-icon></v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>

    <Dialog ref="dialog" />

  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex';
import QuickSearch from './QuickSearch'
import Dialog from './common/Dialog'
import GroupModel from "../models/GroupModel"
import Search from "../services/Search"
import { SearchModel, SearchModelBlock, SearchModelBlockItem } from '../models/SearchModel'

export default {
  name: 'GroupView',
  components: {
    QuickSearch,
    Dialog,
  },
  props: ['group_id', 'title', 'refToolbar'],
  data() {
    return {
      oldName: '',
      debug: false,
      dirty: false,
      rules: {
        required: value => !!value || 'Required.',
        count: value => value.length <= 50 || 'Max 50 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        }
      },
    }
  },
  computed: {
    ...mapGetters(['isDebug', 'data', 'groupItem', 'selectedFolder', 'allToExport', 'exportIds', 'selectedItems',])
  },
  watch: {
    id(val) {
      this.editGroup(val)
    },
    groupItem() {
// console.log('watch groupItem:', val)
      this.$nextTick(() => {
        this.dirty = false
      })
    },
    'groupItem.contacts'() {
// console.log('watch groupItem.contacts')
      this.dirty = true
    }
  },

  mounted() {
    this.refToolbar.$el.parentElement.appendChild(this.$refs.aToolbar.$el)
    this.editGroup(this.group_id)
  },

  methods: {
    editGroup(id) {
      const self = this
      if (id && id !== 'new') {
        new Search(this.$api).load_group(id).then(() => {
          self.oldName = self.groupItem.name
        })
      } else {
        const newGroup = new GroupModel()

        this.selectedItems.forEach(item => {
          newGroup.contacts.push({ value: item.id, text: this.searchText(item) })
        })          
        
        this.$store.commit('setGroupItem', newGroup)
      }
    },
    onSelect({id, text}) {
      this.groupItem.contacts.push({ value: id, text })
    },
    searchText(item) {
      return [item.name, item.first_name, item.company, item.email].filter(Boolean).join(', ')
    },
    onRemove(id) {
      this.groupItem.contacts = this.groupItem.contacts.filter(a => a.value !== id)
    },
    onSave() {
      this._save('save')
    },
    onSaveAs() {
      this._save('saveAs')    
    },
    onRun() {
      this._save('run')
    },
    onDelete() {
      this.$refs.dialog.show({
        type: '',
        title: this.$t('GENERIC_DELETE_ALERT_TITLE'),
        message: this.$t('EXTSEARCH_DELETE_ALERT_GROUP'),
        buttons: [
          {
            label: this.$t('GENERIC_DELETE'),
            close: true,
            default: true,
            callback: () => {
              new Search (this.$api).delete(this.groupItem.item).then(()=>{
                this.editGroup()
              })
            },
          },
          {
            label: this.$t('GENERIC_CANCEL'),
            close: true,
          },
        ]
      })
    },
    onLeave(next) {
      if (this.dirty) {

        next(false)
        this.$refs.dialog.show({
          type: '',
          title: this.$t('GENERIC_UNSAVED_CHANGES_TITLE'),
          message: this.$t('GENERIC_UNSAVED_CHANGES'),
          buttons: [
            {
              label: this.$t('GENERIC_SAVE'),
              close: true,
              default: true,
              callback: () => {
                this.onSave()
                next()
              },
            },
            {
              label: this.$t('GENERIC_DISCARD'),
              close: true,
              default: true,
              callback: () => {
                next()
              },
            },
            {
              label: this.$t('GENERIC_CANCEL'),
              close: true,
            },
          ]
        })
      } else {
        next()
      }
    },
    _save(mode) {
// console.log('_save: ', mode)
      if (mode == 'saveAs'){
        if (this.groupItem.name == this.oldName) {
          this.$refs.dialog.show({
            type: 'warning',
            title: this.$t('RESULTS_CONTACTGROUP_PANEL_ALERT_TEXTFIELD_TITLE'),
            message: this.$t('RESULTS_CONTACTGROUP_PANEL_ALERT_TEXTFIELD_TXT'),
          })
          return
        }
        this.groupItem.item = null 
      }
      if (!this.groupItem.name) {
        this.$refs.dialog.show({
          type: 'warning',
          title: this.$t('EXTSEARCH_ENTER_NAME_TITLE'),
          message: this.$t('EXTSEARCH_INVALID_GROUP'),
        })
        return
      }
      const mSearch = this._prepareMSearch()
      mSearch.item = this.groupItem.item
// console.log(mSearch)
      this.$store.commit('setMSearch', mSearch)
      if (this.groupItem.item) {
        new Search(this.$api).update(this.groupItem.name, 'group')
          .then(res => {
            this.dirty = false
            if (mode === 'save') {
              new Search(this.$api).load_group(res.query._attributes.id).then(() => {
                this.oldName = this.groupItem.name
              })
            }
            else if (mode === 'run') {
              this.$router.push({ name: 'contact.group', params: { search_id: res.query._attributes.id, title: res.query._attributes.name }, hash: this.getNewHash()})
            }
          })
      } else {
        new Search(this.$api).create(this.groupItem.name, 'group', this.selectedFolder)
          .then(res => {
            this.dirty = false
            if (mode === 'save') {
              new Search(this.$api).load_group(res.query._attributes.id).then(() => {
                this.oldName = this.groupItem.name
              })
            }
            else if (mode === 'run') {
              this.$router.push({ name: 'contact.group', params: { search_id: res.query._attributes.id, title: res.query._attributes.name }, hash: this.getNewHash()})
            }
          })
      }
    },
    _prepareMSearch() {
      const mSearch = new SearchModel()
      mSearch.blocks.push(new SearchModelBlock())
      mSearch.blocks[0].searches.push(new SearchModelBlockItem())
      const fields = require('../config/fields.json')
// console.log(fields)
      let field = fields.find(a => a.id === 'id')
      const compares = require('../config/compares.json')
// console.log(compares)
      let compare = compares.default.find(a => a.id === 'equals')
      mSearch.blocks[0].searches[0] = {
        field: field,
        compare: compare,
        values: []
      }
      this.groupItem.contacts.forEach(contact => {
// console.log(contact)
        mSearch.blocks[0].searches[0].values.push(contact.value)
      })
      return mSearch
    },
    appReload(e) {
      if (this.dirty) {
        e.preventDefault()
        e.returnValue = 'Please save' // Chrome only
        return 'Please save' // legacy
      }
    },
    getNewHash() {
      const dt = new Date()
      return '##'+ (dt.getTime()*1000 + dt.getMilliseconds())
    }
  },
  beforeRouteUpdate(to, from, next) {
// console.log('beforeRouteUpdate')
    this.onLeave(next)
  },
  beforeRouteLeave(to, from, next) {
// console.log('beforeRouteLeave')
    this.onLeave(next)
  },
  beforeMount() {
    window.addEventListener('beforeunload', this.appReload)
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.appReload)
    this.$refs.aToolbar.$el.remove()
  },
}
</script>

<style>
.container {
  padding: 12px;
}
.v-card__title {
  position: relative;
}
</style>
